import {
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../../service/api_client";
import {
  CreateFoCSTPayload,
  CreateRegularSTPayload,
  CreateReplacementSTPayload,
  CreateReturnableSTPayload,
  CreateReturnableDCPayload,
  ReturnableDCSourceType,
} from "./model/warehouse_outward_model";

export const RejectWarehouseOutwardApi = async (
  payload: any,
  outward_id: string,
) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/reject/${outward_id}`;
    const res = fetchPut(baseUrl, payload);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ToggleEwayWaiverApi = async (
  outward_id: string,
  waived: boolean,
) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/toggle-eway-waiver/${outward_id}`;
    return await fetchPut(baseUrl, { waived });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const DeleteRejectedeOutwardApi = async (outward_id: string) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/cancel-outward/${outward_id}`;
    const res = fetchPut(baseUrl, {});
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CancelOutwardApi = async (outward_id: string) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/cancel-outward/${outward_id}`;
    return await fetchPut(baseUrl, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ReturnOutwardApi = async (
  formData: FormData,
  outward_id: string,
) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/return-outward/${outward_id}`;
    return await fetchPut(baseUrl, formData, {
      "Content-Type": "multipart/form-data",
    });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const FetchWarehouseDetailsById = async (id: string) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_type/${id}`;
    const res = fetchGet(baseUrl);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UpdateRejectedeSTApi = async (outward_id: string, data: any) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/edit-reject/${outward_id}`;
    const res = fetchPut(baseUrl, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const FetchPOInwardOrderDetailsByIdRepo = async (
  inward_order_id: string,
) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/po-inward-details/${inward_order_id}`;
    const res = fetchGet(baseUrl);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const FetchSTInwardOrderDetailsByIdRepo = async (
  inward_order_id: string,
) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/st-inward-details/${inward_order_id}`;
    const res = fetchGet(baseUrl);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreatePurchaseOrderWarehouseInwardRepo = async (data: any) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc`;
    const res = fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateStockTransferhouseInwardRepo = async (data: any) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/record-st-inward`;
    const res = fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetSTInwardedDevicesAPI = async (inward_order_id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/st-inwarded-devices/${inward_order_id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Failed to fetch inwarded devices",
    };
  }
};

export const GetPOInwardedDevicesAPI = async (inward_order_id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/po-inwarded-devices/${inward_order_id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Failed to fetch inwarded devices",
    };
  }
};

export const GetLinkedInwardForPOAPI = async (
  inward_order_id: string,
  ref_type: string,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/voucher/purchase/grn-summary/${inward_order_id}/${ref_type}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Failed to fetch inwarded devices",
    };
  }
};

export const raiseInwardDisputeApi = async (data: any) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/quarantine/dispute-raise`;
    const res = fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UpdateDisputeStatusApi = async (data: {
  status: string;
  reason: string;
  dispute_id: string;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/quarantine/dispute-update`;
    const res = fetchPost(url, { ...data });
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const fetchAllQuarantinedList = async (filters: any) => {
  try {
    const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/quarantine/list`;
    const url = baseUrl + toQueryString(filters);
    console.log("url ", url);
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return {
      success: false,
      error: error.message || "Failed to fetch quarantined list",
    };
  }
};

export const GetItemWAC = async (itemCode: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/wac/${itemCode}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetAvailableQty = async (warehouseId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/items/warehouses?warehouse_id=${warehouseId}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetDeviceDetailsFromComplaint = async (complaintId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/device_ids/${complaintId}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetHomeAddressByDeviceId = async (deviceId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/home-address/${deviceId}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateRegularStockTransfer = async (
  payload: CreateRegularSTPayload,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer`;
    return await fetchPost(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UpdatePendingHomeAppST = async (
  stId: string,
  payload: CreateRegularSTPayload,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer/${stId}/confirm-home-request`;
    return await fetchPut(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateReturnableStockTransfer = async (
  payload: CreateReturnableSTPayload,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer-returnable`;
    return await fetchPost(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateReturnableDC = async (
  payload: CreateReturnableDCPayload,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer-returnable-dc`;
    return await fetchPost(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetReturnableDCSource = async (
  type: ReturnableDCSourceType,
  id: string,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer/returnable-dc-source/${type.toLowerCase()}/${id}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetReturnableDCOrdersByCustomer = async (
  customerUid: string,
  fromDate: string,
  toDate: string,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer/returnable-dc-source/by-customer${toQueryString(
      { customer_uid: customerUid, fromDate, toDate },
    )}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Fetches + merges every delivered SO for the customer/date-range in one
// backend call (server fetches orders in parallel) instead of one round
// trip per order.
export const GetReturnableDCOrdersByCustomerConsolidated = async (
  customerUid: string,
  fromDate: string,
  toDate: string,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer/returnable-dc-source/by-customer/consolidated${toQueryString(
      { customer_uid: customerUid, fromDate, toDate },
    )}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateFoCStockTransfer = async (payload: CreateFoCSTPayload) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer-foc`;
    return await fetchPost(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateReplacementStockTransfer = async (
  payload: CreateReplacementSTPayload,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer-replacement`;
    return await fetchPost(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

/** ---------------- CUSTOMER ADDRESSES ---------------- */

export const GetCustomerBillingAddresses = async (userId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/billing-profiles/user/${userId}/Billing`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetCustomerShippingAddresses = async (userId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/billing-profiles/user/${userId}/Delivery`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

/** ---------------- VENDOR WAREHOUSE ADDRESSES ---------------- */

export const GetVendorWarehouses = async (vendorId: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/warehouse_type/get-vendor-warehouses/${vendorId}`;
    return await fetchGet(url);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ConvertSTToSO = async (
  stId: string,
  items: { inventoryItemCode: string; salePrice: number }[],
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/stock-transfer/${stId}/convert-to-order`;

    return await fetchPost(url, { items });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const BulkCheckItemAvailabilityApi = async (
  from_warehouse_id: string,
  items: { item_code: string; quantity: number }[],
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/bulk-check-availability`;
    return await fetchPost(url, { from_warehouse_id, items });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const BulkApproveSTFGApi = async (ids: string[]) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/approve-fg-ST`;
    return await fetchPut(url, { ids });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const fetchWarehouseDashboardSummary = async () => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/create-grn-by-spoc/warehouse-dashboard-summary`;
  return fetchGet(url);
};

// --- Complaint-to-Replacement pipeline: Draft ST fill + two-stage approval ---

const REPLACEMENT_ST_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/outward-inventory/replacement-st`;

export const SubmitDraftReplacementST = async (
  id: string,
  payload: {
    items: any[];
    from_warehouse_id: string;
    from_warehouse_name?: string;
    narration?: string;
    selected_device_ids?: string[];
    customer_name?: string;
    contact_name?: string;
    contact_number?: string;
    // billing_address is not accepted here — the backend always derives it
    // from from_warehouse_id's own GST address (the seller), never the
    // customer's address.
    shipping_address?: Record<string, any>;
    faulty_items?: any[];
  },
) => {
  try {
    const url = `${REPLACEMENT_ST_BASE}/${id}/submit`;
    return await fetchPut(url, payload);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const HwApproveReplacementST = async (id: string) => {
  try {
    return await fetchPut(`${REPLACEMENT_ST_BASE}/${id}/hw-approve`, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const HwRejectReplacementST = async (id: string, reason: string) => {
  try {
    return await fetchPut(`${REPLACEMENT_ST_BASE}/${id}/hw-reject`, {
      reason,
    });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const BizApproveReplacementST = async (id: string) => {
  try {
    return await fetchPut(`${REPLACEMENT_ST_BASE}/${id}/biz-approve`, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const BizRejectReplacementST = async (id: string, reason: string) => {
  try {
    return await fetchPut(`${REPLACEMENT_ST_BASE}/${id}/biz-reject`, {
      reason,
    });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const RetryReverseDC = async (id: string) => {
  try {
    return await fetchPut(`${REPLACEMENT_ST_BASE}/${id}/retry-reverse-dc`, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ListReplacementSTApprovals = async () => {
  try {
    return await fetchGet(`${REPLACEMENT_ST_BASE}/pending-approvals`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
